export enum ProductLayout {
    Grid,
    List
}
